import React, { createContext, useContext, useState, ReactNode } from 'react';
import { InvoiceDTO } from '../models/InvoiceDTO';

interface InvoiceContextProps {
  invoice: InvoiceDTO | null;
  setInvoice: (invoice: InvoiceDTO) => void;
}

const InvoiceContext = createContext<InvoiceContextProps | undefined>(undefined);

export const InvoiceProvider: React.FC = ({ children }) => {
  const [invoice, setInvoice] = useState<InvoiceDTO | null>(null);

  return (
    <InvoiceContext.Provider value={{ invoice, setInvoice }}>
      {children}
    </InvoiceContext.Provider>
  );
}

export const useInvoice = () => {
  const context = useContext(InvoiceContext);
  if (!context) {
    throw new Error('useInvoice must be used within an InvoiceProvider');
  }
  return context;
}